import React from 'react';
import { useStore } from '../store';
import { ColorPicker } from './ColorPicker';
import { FontPicker } from './FontPicker';

interface TextPanelProps {
  colors: string[];
  allowCustomColors?: boolean;
  allowedFonts?: Array<{ name: string; value: string }>;
  textId: string;
}

export const TextPanel: React.FC<TextPanelProps> = ({
  colors,
  allowCustomColors = true,
  allowedFonts,
  textId
}) => {
  const { textElements, updateTextElement } = useStore();
  const textElement = textElements.find(el => el.id === textId);

  if (!textElement) return null;

  const handleUpdate = (updates: Partial<typeof textElement>) => {
    updateTextElement(textId, updates);
  };

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Texte
        </label>
        <input
          type="text"
          value={textElement.text}
          onChange={(e) => handleUpdate({ text: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Style d'écriture
        </label>
        <FontPicker
          selectedFont={textElement.font}
          onFontSelect={(font) => handleUpdate({ font })}
          allowedFonts={allowedFonts}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Couleur
        </label>
        <ColorPicker
          colors={colors}
          selectedColor={textElement.color}
          onColorSelect={(color) => handleUpdate({ color })}
          allowCustom={allowCustomColors}
          type="text"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Taille
        </label>
        <input
          type="range"
          min="12"
          max="72"
          value={textElement.size}
          onChange={(e) => handleUpdate({ size: Number(e.target.value) })}
          className="w-full"
        />
        <div className="text-sm text-gray-500 mt-1">{textElement.size}px</div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Rotation
        </label>
        <input
          type="range"
          min="-180"
          max="180"
          value={textElement.rotation}
          onChange={(e) => handleUpdate({ rotation: Number(e.target.value) })}
          className="w-full"
        />
        <div className="text-sm text-gray-500 mt-1">{textElement.rotation}°</div>
      </div>
    </div>
  );
};